import AtomImage from '@s-ui/react-atom-image'
import {useSuiContext} from '@s-ui/react-context'

const BASE_CLASS_NAME = 'mt-PublishMyAdWithPlate-stepFormSellerPlate-form-inputAddonPlate'

const FormSellerPlateInputAddonPlate = () => {
  const {domain} = useSuiContext()
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  return (
    <div className={BASE_CLASS_NAME}>
      <div className={`${BASE_CLASS_NAME}ImageWrapper`}>
        <AtomImage
          aria-hidden="true"
          role="presentation"
          src={`${URL_STATICS_IMAGES}common/plates/spanish-registration-plate.svg`}
        />
      </div>
    </div>
  )
}

FormSellerPlateInputAddonPlate.displayName = 'FormSellerPlateInputAddonPlate'

export default FormSellerPlateInputAddonPlate
